import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class UrlService {

    constructor() { }

    public getParam( paramName: string, defValue?: string ) {
        const url = window.location.href;
        let paramValue = null;
        if (url.includes('?')) {
          const httpParams = new HttpParams({ fromString: url.split('?')[1] });
          paramValue = httpParams.get(paramName);
        }
        if (paramValue == null) {
            paramValue = defValue;
        }
        return paramValue;
    }
    
    
}